<template>
  <path pid="0" d="M20.85 15.64a1 1 0 00-.12-1.41 12 12 0 00-15.37 0 1 1 0 00-.12 1.41 1 1 0 001.4.12 10 10 0 0112.81 0 1 1 0 001.4-.12z"/><path pid="1" d="M9 17.74a1 1 0 00-.24 1.4 1 1 0 001.39.23 5 5 0 015.8 0 1 1 0 001.39-.23 1 1 0 00-.24-1.4 7 7 0 00-8.1 0zM3.08 12.2a15 15 0 0119.84 0 1 1 0 001.33-1.5 17 17 0 00-22.5 0 1 1 0 001.33 1.5z"/>
</template>
